import React from "react";
import BetaHistogram from "../../components/beta-histogram";
import {
  getPercentileText2,
  percentileToSD,
  sdToOR,
} from "../../utils/results";

export const Mars_Dep_Results = (props) => {
  const { crm, result, userName, nameEndsWithS } = props;

  let testComponent;
  let percentile = null;

  if (result.hasOwnProperty("percentile")) {
    percentile = result["percentile"];
  }

  const sd =
    percentile !== undefined && percentile !== null
      ? percentileToSD(percentile)
      : null;

  const orPerSD = 1.26;

  const oddsRatio =
    sd !== null && Number.isFinite(sd) ? sdToOR(sd, orPerSD, true) : null;

  const sdDirection = sd > 0 ? "above" : sd < 0 ? "below" : "at";

  const oddsDirection =
    oddsRatio > 1 ? "increased" : oddsRatio < 1 ? "decreased" : "unchanged";

    const sdText =
  sd === 0
    ? "at the mean"
    : `${Math.abs(sd).toFixed(2)} standard deviations ${
        sd > 0 ? "above" : "below"
      } the mean`;
  console.log("result :", result);
  console.log("percentile from UER :", percentile);
  console.log("SD :", sd);
  console.log("odds ratio :", oddsRatio);

  if (result["value"] !== null) {
    testComponent = (
      <div>
        <div className="title-break">
          <span>Your Results</span>
        </div>

        <div className="card">
          <p>
            To use the graph, find the red line that shows your genetic score.
            The blue histogram shows the number of people and their genetic
            scores. The bin containing your score tells how many other people
            have a score like yours. If your score is on the{" "}
            <strong>right side of the histogram</strong>, you will tend to have
            higher risk for depression. (Units for Beta are arbitrary.)
          </p>

          <div>
            <BetaHistogram
              crm={crm}
              result={result}
              crmKey="results-Mars_Dep-histogram"
            />

            {percentile !== null &&
              sd !== null &&
              Number.isFinite(sd) &&
              oddsRatio !== null &&
              Number.isFinite(oddsRatio) && (
<p>
  Your score is in the{" "}
  <strong>{getPercentileText2(percentile)}</strong>, which is{" "}
  <strong>{sdText}</strong> and indicates{" "}
  <strong>{oddsDirection}</strong> odds of depression, with an odds
  ratio of <strong>{oddsRatio.toFixed(2)}</strong>.
</p>
              )}
          </div>
        </div>

        <div className="title-break">
          <span>How To Interpret Your Results</span>
        </div>

        <div className="title-break">
          <span>Comments</span>
        </div>

        <div className="card">
          <p>
            This study developed a polygenic risk score for depression that
            includes 1,091,614 total variants based on 306,418 individuals.
          </p>

          <p>OR per SD = 1.26 (1.22–1.30) for depression.</p>

          <p>
            The study was limited to individuals of European ancestry. It is not
            clear how well the genetics perform for other ancestries.
          </p>
        </div>
      </div>
    );

    return (
      <div>
        <div className="title-margins">
          <h2>
            {userName ? `${userName}'${nameEndsWithS ? "" : "s"}` : ""} Results
            for Depression
          </h2>

          <h5>
            <a href="https://pubmed.ncbi.nlm.nih.gov/36347255/">
              Mars et al., 2021
            </a>
          </h5>
        </div>

        {testComponent}
      </div>
    );
  }

  return null;
};

export default Mars_Dep_Results;
